const salesNavProfile = [
  '.profile-topcard-person-entity__content', // Contact Page - Contact content (Lusha Contacts)
  '#experience-section', // Contacts Page - Contact Experience Organization (23/3/2022)
];

const salesNavBulk = [
  '.result-lockup__name', // Search Page - Results container (Bulk Enrich)
  '.artdeco-entity-lockup__title', // Search Page V2 - Results container (Bulk Enrich)
  '.empty-search-results', // Search Page - Empty Results Container (Bulk Enrich)
  '.error-message', // Search Page - Error Container (Bulk Enrich)
  '.search-results__no-results', // Search Page - No Results Container (Bulk Enrich)
  '.list-people-detail-header__entity', // Leads Page - Results Container (Bulk Enrich)
];

const salesNavCompany = [
  '.link-without-visited-and-hover-state', // Company page
];

export const LINKEDIN_SALES_NAVIGATOR_INDICATORS_BY_CONTEXT_TYPE = {
  profile: salesNavProfile,
  bulk: salesNavBulk,
  company: salesNavCompany,
  unknown: [...salesNavProfile, ...salesNavBulk, ...salesNavCompany],
};
